import { Duration } from "luxon";

export class K {
  static snackBarVisibilityTime = Duration.fromDurationLike({ seconds: 5 });
}